<template>
  <div class="table-handle-result">
    <header>
      <p class="title-header"><span style="font-weight: bold;">{{history?.metric_label}} #{{history?.issue_id }} | {{history?.handler_name}}</span> đã chuyển kết quả xử lý thành <span style="font-weight: bold;">{{history?.handling_option}}</span></p>
      <p class="title-time">{{history?.created_at}}</p>
    </header>
    <section class="row mt-5">
      <p class="col-lg-3">Ghi chú xử lý:</p>
      <p class="col-lg-9">{{history?.note}}</p>
      <p class="col-lg-3">Đo lường sau xử lý:</p>
      <p class="col-lg-9">{{history?.measure_after?'Có':'Không'}}</p>
      <p class="col-lg-3" v-if="history?.measurement_range_from">Khoảng thời gian đo lường:</p>
      <p class="col-lg-9" v-if="history?.measurement_range_from">Từ {{history?.measurement_range_from}} đến {{history?.measurement_range_to}}</p>
      <p class="col-lg-3" v-if="history?.target_percent">Mục tiêu:</p>
      <p class="col-lg-9" v-if="history?.target_percent">{{history?.target_percent}}%</p>
      <p class="col-lg-3" v-if="history?.result_at">Thời gian nhận kết quả:</p>
      <p class="col-lg-9" v-if="history?.result_at">{{history?.result_at}}</p>
    </section>

  </div>
</template>
<script>
export default {
  name: "HandleResult",
  props: {
    history: {
      type: Object,
      default: () => null
    }
  },
}
</script>
<style scoped>
.table-handle-result {
  width: 100%;
  border: 1px solid #929292;
  padding: 10px;
  background-color: white;
}

.title-header {
  color: #4C0192;
}

.title-time {

}

header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid #929292;
}

</style>